import ProfileInfoEdit from "../../../components/profileInfoEdit/ProfileInfoEdit";
import { Container } from "./EditProfileStyles";

const EditProfile = () => {
  return (
    <Container>
      <ProfileInfoEdit />
    </Container>
  );
};

export default EditProfile;
